import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { breadcrumbList } from "@/lib/schema";
import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { ContactContent } from "@/components/ContactContent";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact IraqCert | ISO Preparation & Supplier Registration" },
      {
        name: "description",
        content:
          "Discuss ISO preparation or supplier registration with IraqCert. Start with your activity, location and buyer requirement by WhatsApp, phone or email.",
      },
      {
        property: "og:title",
        content: "Contact IraqCert | ISO Preparation & Supplier Registration",
      },
      {
        property: "og:description",
        content:
          "Discuss ISO preparation or supplier registration with IraqCert. Start with your activity, location and buyer requirement by WhatsApp, phone or email.",
      },
      { property: "og:url", content: absolute("/contact") },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/contact") }, ...hreflangLinks("/contact")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbList([
            { name: "Home", path: "/" },
            { name: "Contact", path: "/contact" },
          ]),
        ),
      },
    ],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Navbar />
      <main>
        <ContactContent />
      </main>
      <Footer />
    </div>
  );
}
